import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "296",
  "slug": "spot-poland-from-satellite-imagery",
  "title": "How to Recognise Poland in Satellite Images",
  "excerpt": "Poland has a Baltic coast in the north, extensive inland plains, and mountain terrain along parts of the southern border.",
  "date": "2026-04-21",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/poland.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Poland has a Baltic coast in the north, extensive inland plains, and mountain terrain along parts of the southern border. The Masurian Lake District lies in the northeast. Detailed imagery may show long narrow fields, but agricultural patterns vary within regions and across the country."
    },
    {
      "type": "heading",
      "text": "The Baltic lowlands and southern mountains"
    },
    {
      "type": "paragraph",
      "text": "Compare the Masurian lakes with the southern edge near the Tatras. Look for the change in relief and water distribution rather than a supposedly national style of village."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Long strips are not uniquely Polish, and field boundaries do not trace the modern German-Polish border. Lithuania, Belarus, Germany, and other neighbours share parts of this landscape. A lake group, river course, or mountain edge can supply better context."
    }
  ],
  "imageAlt": "Poland regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
